import React, { PropTypes } from 'react'
import { Container, Row, Col } from 'react-grid-system'
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table'

export default class CompetitionsResult extends React.Component {
  static propTypes = {
    model: PropTypes.object
  }
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };
  state = {}

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  
  render() {
    let { palette: {labelColor}, tableHeaderColumn } = this.context.muiTheme

    let {
      model,
    } = this.props;
    const { start_time, end_time, statistics, winners = [] } = model || {}

    const { participated_total = 0, participated_last_24_hours = 0 } = statistics || {}

    const estimated = ((end_time - Date.now()) > 0 ? Date.now() : end_time) - start_time

    return (
      estimated > 0 ? <Container style={{ margin: 0, paddingTop: 80, fontSize: 14 }}>
        <Row>
          <Col>
            <Row>
              <Col xs={4}>
                <Row style={{ paddingBottom: 10 }}>
                  <Col xs={7}>Total participants:</Col><Col xs={4}>{ participated_total }</Col>
                </Row>
                <Row style={{ paddingBottom: 10 }}>
                  <Col xs={7}>Joined in last 24h:</Col><Col xs={4}>{ participated_last_24_hours }</Col>
                </Row>
              </Col>
              <Col xs={8}>
                { winners.length ? <Table selectable={false}>
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                              style={{ backgroundColor: tableHeaderColumn.bgColor }}>
                    <TableRow>
                      <TableHeaderColumn style={{ width: 50, color: labelColor }}>Number</TableHeaderColumn>
                      <TableHeaderColumn style={{ width: '40%', color: labelColor }}>Name</TableHeaderColumn>
                      <TableHeaderColumn style={{ width: '40%', color: labelColor }}>Email</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {
                      winners.map((winner, index) => <TableRow key={winner.email}>
                          <TableRowColumn style={{ width: 50 }}>{ index + 1 }</TableRowColumn>
                          <TableRowColumn style={{ width: '40%', textAlign: 'left' }}>{ winner.first_name } { winner.last_name }</TableRowColumn>
                          <TableRowColumn style={{ width: '40%', textAlign: 'left' }}><a href={`mailto:${winner.email}`}>{ winner.email }</a></TableRowColumn>
                        </TableRow>
                      )
                    }
                  </TableBody>
                </Table> : null }
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>  : null
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionResult/CompetitionsResult.jsx